import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import GitGuardianConfigListing from './GitGuardianConfigListing';
import GitGuardianCredentialsForm from './GitGuardianCredentialsForm';

export default function GitGuardianPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={GitGuardianCredentialsForm}
            PullConfigListingView={GitGuardianConfigListing}
            RunOnDemandButtonText={'Sync tool sources'}
        />
    )
}